import React from 'react';
import './LegalPages.css';

function PrivacyPolicy({ onBack }) {
  return (
    <section className="legal-page">
      <div className="legal-container">
        <button className="back-button" onClick={onBack}>← Back</button>
        
        <h1>Privacy Policy</h1>
        <p><strong>Last Updated: April 2026</strong></p>

        <h2>1. Introduction</h2>
        <p>
          Northstar Bridge Commerce LLC ("Company", "we", "our", or "us") is committed to protecting your privacy. 
          This Privacy Policy explains our data handling practices for the northstarbridgeco.com website and services.
        </p>

        <h2>2. Information We Collect</h2>
        <p>We collect information you provide directly:</p>
        <ul>
          <li><strong>Contact Information:</strong> name, company, email, phone number</li>
          <li><strong>Inquiry Data:</strong> subject matter and messages through contact forms</li>
          <li><strong>Business Information:</strong> company details relevant to wholesale partnerships</li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <p>Your information is used to:</p>
        <ul>
          <li>Respond to inquiries and business requests</li>
          <li>Facilitate wholesale partnerships and communications</li>
          <li>Send promotional materials (with consent)</li>
          <li>Improve our services and website functionality</li>
        </ul>

        <h2>4. Information Sharing</h2>
        <p>
          We do not sell, trade, or rent your personal information to third parties. 
          We may share information only with service providers necessary for business operations.
        </p>

        <h2>5. Data Security</h2>
        <p>
          We implement industry-standard security measures to protect your information 
          from unauthorized access, alteration, and destruction.
        </p>

        <h2>6. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal information</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your information</li>
          <li>Opt-out of marketing communications</li>
        </ul>

        <h2>7. Contact Us</h2>
        <p>
          For privacy concerns or data requests, contact:<br />
          <strong>Northstar Bridge Commerce LLC</strong><br />
          Email: <a href="mailto:sales@northstarbridgeco.com">sales@northstarbridgeco.com</a><br />
          Phone: <a href="tel:+13023858016">+1 302 385 8016</a>
        </p>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
